import  { useState, useEffect, useRef } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import TodoDataService from '../hooks/services'


// import Paper from '@mui/material/Paper';
import Fab from '@mui/material/Fab';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import './App.css';


import HeaderColumba from '../components/Header_Columba';
import FooterColumba from '../components/Footer_Columba';
import routes from '../routes/routes';
import Box from '@mui/material/Box';




function App() {
  const [HideFoother, setHideFoother] = useState(false)
  const [HeightWindow, setHeightWindow] = useState(window.innerHeight)
  const [HeightPage, setHeightPage] = useState(0)

  const BodyRef = useRef();
  const FooterRef = useRef();
  const ResizeObserverRef = useRef(null);

  // const seccionRef = useRef(null);
  const fabRef = useRef(null);
  const [mostrarBoton, setMostrarBoton] = useState(true);
  const [hayScroll, setHayScroll] = useState(false);

  
  useEffect(() => {
    const verificarColision = () => {
      const fab = fabRef.current;
      const footer = FooterRef.current;
      const seccion = ResizeObserverRef.current;
  
      const scrollDisponible = document.documentElement.scrollHeight > window.innerHeight;
      setHayScroll(scrollDisponible);

      if (scrollDisponible) 
        {
          
      if (!fab || !footer || !seccion) return;
  
      const fabRect = fab.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();
      const seccionRect = seccion.getBoundingClientRect();
  
      const MARGEN = 0;
  
      const estaSobreFooter = fabRect.bottom >= (footerRect.top - MARGEN);
      const estaDentroDeSeccion = (
        fabRect.bottom > seccionRect.top &&
        fabRect.top < seccionRect.bottom
      );
  
      const debeMostrar = estaDentroDeSeccion && !estaSobreFooter;
  
      // Solo actualiza si cambia el valor
      setMostrarBoton(prev => {
        if (prev !== debeMostrar) return debeMostrar;
        return prev;
      });
    };
        }





  
    const handle = () => {
      requestAnimationFrame(verificarColision); // mejor para scroll suave
    };
  
    window.addEventListener('scroll', handle);
    window.addEventListener('resize', handle);
    handle(); // Verificar una vez al inicio
  
    return () => {
      window.removeEventListener('scroll', handle);
      window.removeEventListener('resize', handle);
    };
  }, []);
  


  const handleResize = () => {
    setHeightWindow(window.innerHeight);

    if (BodyRef.current && FooterRef.current) {
      setHeightPage(BodyRef.current.offsetHeight + FooterRef.current.offsetHeight);
      // Aquí puedes hacer lo que necesites con la altura del footer
    }
  };

  const handleResizeClases = () => {
    setHeightWindow(window.innerHeight);
    if (BodyRef.current && FooterRef.current) {
      setHeightPage(BodyRef.current.offsetHeight + FooterRef.current.offsetHeight);
      // Aquí puedes hacer lo que necesites con la altura del footer
    }

  };



  
  useEffect(() => {
    window.addEventListener('resize', handleResizeClases);
    handleResizeClases(); // Llama a la función inicialmente para establecer la altura correcta

    const resizeObserver = new ResizeObserver(() => {
      handleResizeClases();
    });

    if (ResizeObserverRef.current) {
      resizeObserver.observe(ResizeObserverRef.current);
    }

    return () => {
      window.removeEventListener('resize', handleResizeClases);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);

useEffect(() => {
    const seo = document.getElementById('seo-content');
    if (seo) seo.remove();
  }, []);


  const OcultarFoother = () => {
    setHideFoother(!HideFoother);
  }

  return (
    <BrowserRouter>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignContent: 'space-between', padding: '0px', margin: '0px' }} className="App">


        <div ref={BodyRef} >
          <Box sx={{ height: '20%' }} pb='75px !important'>
            <HeaderColumba ListLink={routes.Principales} />
          </Box>
          <div ref={ResizeObserverRef} style={{ height: '55%'}}>
            <Routes>

              {
                routes.Principales.map((rute, index) => (
                  <Route key={index} path={rute.path} element={<rute.component  OcultarFoother={OcultarFoother} />} />
                ))
              }
               {
                routes.Secundarias.map((rute, index) => (
                  <Route key={index} path={rute.path} element={<rute.component  OcultarFoother={OcultarFoother} />} />
                ))
              }

              <Route
                path="/SetsFunerarios/Cobertura"
                element={<Navigate to={`/SetsFunerarios/Cobertura/1`} />}
              /> 

        
            </Routes>
            <Fab id='whatsapp-btn'
  ref={fabRef}
  aria-label="add"
  onClick={() => window.open('https://wa.me/' + TodoDataService.GetNumberCall2(), '_blank')}
  sx={{
position:  'fixed',    bottom: 16,
    right: {xs:10,sm:10,lg:16},
    backgroundColor: '#25D366',
    color: '#fff',
    width: {xs:40, sm: 40, lg: 56 },
    height: {xs:40, sm: 40, lg: 56 },
    minHeight: 'auto',
    boxShadow: 3,
    zIndex: 1200,
    opacity:!hayScroll?1: mostrarBoton  ? 1 : 0,
    pointerEvents:!hayScroll?'auto': mostrarBoton ? 'auto' : 'none',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      backgroundColor: '#1ebc57', // puedes cambiar este color al que prefieras
    },
  }}
>
  <WhatsAppIcon sx={{ fontSize: {xs:25, sm: 25, lg: 32 } }} />
</Fab>
          </div>
   
        </div>
        <Box mt={HeightWindow < HeightPage ? '0px' : `${HeightWindow - HeightPage}px`}></Box>
        <div ref={FooterRef}>
          <FooterColumba HideFoother={HideFoother} />
        </div>


      </Box>
    </BrowserRouter>

  );
}

export default App;
